import { fetcher } from "utils";

export const post__members__carts = (optionIds: number[]): Promise<" "> =>
  fetcher.post("/members/carts", { optionIds });
